import todoList from "../../images/todo.png";
import urlShort from "../../images/urlshortnerapp.png";
import dashboardImg from "../../images/dashboardpic.png";
import lotteryImg from "../../images/lotterycontract.png";
import campaignImg from "../../images/campaigns.png";
import sortingImage from "../../images/sorting.png";
import authImage from "../../images/authpic.png";
import nftImage from "../../images/nftpic.png";

export const portfolioData = [
  {
    sectionId: 2,
    projectName: "Todo List",
    projectLink: "https://github.com/binyamdawit/Todo-List",
    image: todoList,
  },
  {
    sectionId: 2,
    projectName: "URL Shortener",
    projectLink: "https://github.com/binyamdawit/URL-Shortener",
    image: urlShort,
  },
  {
    sectionId: 4,
    projectName: "Admin Dashboard",
    projectLink: "https://github.com/binyamdawit/Dashboard-App.git",
    image: dashboardImg,
  },
  {
    sectionId: 5,
    projectName: "Kickstarter",
    projectLink: "https://github.com/binyamdawit/Kickstart-Project",
    image: campaignImg,
  },
  {
    sectionId: 5,
    projectName: "Lottery Contract",
    projectLink: "https://lotterycontractdev.netlify.app/",
    image: lotteryImg,
  },
  {
    sectionId: 2,
    projectName: "Authentication & Security",
    projectLink: "https://github.com/binyamdawit/Authentication-Level-6-Final",
    image: authImage,
  },
  {
    sectionId: 3,
    projectName: "NFT Marketplace",
    projectLink: "https://nftmarketplace-gamma.vercel.app/",
    image: nftImage,
  },
  {
    sectionId: 3,
    projectName: "Sorting Visualizer",
    projectLink: "https://sorting-visualizer-app-xi.vercel.app/",
    image: sortingImage,
  },
];

export const filterOptions = [
  {
    label: "ALL",
    id: 1,
  },
  {
    label: "SIMPLE",
    id: 2,
  },
  {
    label: "INTERMEDIATE",
    id: 3,
  },
  {
    label: "CAPSTONE",
    id: 4,
  },
  {
    label: "WEB3",
    id: 5,
  },
];
